import VColumnAvatar from './index.vue';

export default {
  install: (Vue) => Vue.component('VColumnAvatar', VColumnAvatar),
};
